
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 139528"}},[_c('path',{attrs:{"data-name":"Path 147259","d":"M5.804 9.527l5.378 5.1a.91.91 0 001.239 0 .8.8 0 000-1.174L7.661 8.94l4.758-4.51a.8.8 0 000-1.174.91.91 0 00-1.239 0L5.803 8.353a.8.8 0 000 1.174z","fill":"#090A0A"}})])])
          )
        }
      }
    